import {memo} from 'react'
import {PopoverText} from '../../../../../../components/Popover/Popover'
import dateformat from 'src/utils/dateformat'
import { Link } from 'react-router-dom'
import { KTSVG } from 'src/_metronic/helpers'
import { useTranslation } from 'react-i18next'

interface RowDataProps {
  items: any[]
  rowNumber: number,
  onEdit: (data: any) => void
  onDetail: (data: any) => void
}

const getCurrency = (sector: any) => {
  if(!sector) return '-'

  if(sector == 3) return 'USD'
  return 'IDR'
}

export const RowData = memo((props: RowDataProps) => {
  const {items, rowNumber, onEdit, onDetail} = props;
  const {t} = useTranslation()

  return (
    <>
      {items.map((item, index) => (
        <tr key={item?.id ?? index}>
          <td>{index + 1 + rowNumber}</td>
          <td>
            <Link className='fw-bold cursor-pointer hover-underline'
                style={{color: '#274070'}}
                to={('/management/so/detail/' + parseInt(item['so_number']))}>
              13{item['so_number']}
            </Link>
          </td>
          <td>
            {
              [
                item?.customer_title, 
                item?.customer_name
              ]
              .filter((i) => i).join(' ')
            }
          </td>
          <td>{item?.status}</td>
          <td>
            <PopoverText
              content={item?.message ? item?.message : '-'}
              index={index}
              trigger='click'
              className='desc-slicee'
            />
          </td>
          <td>{dateformat(item?.execution_date as string, {showtime: true})}</td>
          <td>{item?.sap_number || '-'}</td>
          <td>{item?.dp_req_sap || '-'}</td>
          <td>{item?.billing_number_sap || '-'}</td>
          <td>{item?.bank_gl_account || '-'}</td>
          <td>{item?.clearing_doc_1 || '-'}</td>
          <td>{item?.clearing_doc_2 || '-'}</td>
          <td>{ getCurrency(item?.sector_id) }</td>
          <td>{item?.bank_payment || '-'}</td>
          <td>
            <button
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-2'
              title={t('Detail')}
              onClick={() => onDetail(item)}
            >
              <KTSVG path='/media/icons/duotune/file-text-fill.svg' className='svg-icon-3' />
            </button>
            <button
              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
              title={t('Edit')}
              onClick={() => onEdit(item)}
            >
              <KTSVG path='/media/icons/duotune/pencil-fill.svg' className='svg-icon-3' />
            </button>
          </td>
        </tr>
      ))}
    </>
  )
})
